import React, { Component } from "react"

/* Constants */
import { utils, closed } from '../constants'

/* Picture */
import { Card } from "../components"



/* Widget Dealer Cards */
class DealerCards extends Component {

    _result = () => {

        const { game } = this.props

        if (game) {

            if (game.level === 0) {
                return <div className="dealer-game-status red">{utils.translate('NO GAME')}</div>
            }

            const text = `${utils.translate(game.name)}${game.hasAceKing ? ` + ${utils.translate('ACE KING')}` : ""}`
            let size = "default"

            if (text.length > 20) {
                size = "smaller"
            }

            if (game.level > 0) {
                return (<div className={`dealer-game-status green ${size}`}>{text}</div>)
            }

        }
    }


    render = () => {

        const { cards, game } = this.props
        let dealerCards = utils.getUniqueValues(cards, "uuid")

        return (
            <div className="dealer-container">
                
                <div className="dealer-container-header">
                    <div className="dealer-container-title">{utils.translate("DEALER'S HAND")}</div>
                    {this._result()}
                </div>

                <div className="dealer-cards">
                    {dealerCards.map((card, index) => {

                        const status = game || (dealerCards[0] && dealerCards[0].id)
                        const key = index === 4 ? card.uuid : index
                        const style = card.dealer === true ? "animated" : ""

                        return (
                            <div className={`dealer-card`} key={`d-${key}`}>
                                <div className={`dealer-flip-card  ${status ? 'open' : 'hidden'}`}>
                                    <div className="dealer-flip-card-inner">
                                        <div className="dealer-flip-card-front">
                                            <img src={closed.image} alt="Closed" />
                                        </div>
                                        <div className={`dealer-flip-card-back`}>
                                            <div className={`${style}`}>
                                                {status ? <Card data={card.name} /> : <img src={closed.image} alt="Closed" />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )

                    })}
                </div>

                {
                    dealerCards.length <= 2 ?
                        <div className="dealer-spaces">
                            {[1, 2].map(key =>
                                <div key={`${key}`} className="dealer-space">
                                    <div className="dealer-space-circle">
                                        <div className="dealer-space-diamond"></div>
                                    </div>
                                    <div className="dealer-space-round" />
                                </div>
                            )}
                        </div>
                        : null
                }


            </div>
        )
    }

}

export default DealerCards